import { CustomComponentProps } from "utils/types/general.types";

export type CardProps = CustomComponentProps & {
    children: React.ReactNode;
};
const Card = ({ children, className, style }: CardProps) => {
    return (
        <div
            className={`${className} shadow-md bg-neutral-100 dark:bg-momeento-300 px-4 py-4 rounded `}
            style={style}
        >
            {children}
        </div>
    );
};

export default Card;
